import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum-slim';
import { IS_LOCAL_HOST } from '@utils/constants';

if (
  typeof window !== 'undefined' &&
  process.env.NEXT_PUBLIC_DEPLOY_ENVIRONMENT !== 'development' &&
  !IS_LOCAL_HOST
) {
  const DATADOG_SAMPLING = 100;

  // https://datadog-rum-reverse-proxy.soundxyz.workers.dev/

  const env = window.location.href.includes('pre-prod.sound.xyz')
    ? 'pre-prod'
    : process.env.NEXT_PUBLIC_DEPLOY_ENVIRONMENT;

  datadogRum.init({
    applicationId: '0caddd78-ea22-49ec-ab27-3db631238d60',
    clientToken: 'pub3f5e3704d7644892f8275635d585205d',
    site: 'datadoghq.com',
    proxy: 'https://datadogrum.sound.xyz/',
    service: 'webapp',
    env,
    // Specify a version number to identify the deployed version of your application in Datadog
    version: process.env.NEXT_PUBLIC_WEBAPP_VERSION,
    sessionSampleRate: DATADOG_SAMPLING,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackFrustrations: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    beforeSend(event) {
      // discard a RUM error if its message includes 'Minified React error'
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const errorMessage = (event?.context?.error as any)?.message ?? null;

      if (
        event.type === 'action' &&
        !!errorMessage &&
        errorMessage.includes('Minified React error')
      ) {
        return false;
      }

      return true;
    },
  });

  datadogLogs.init({
    clientToken: 'pub223d9a7686616d1a30f7590736944870',
    site: 'datadoghq.com',
    service: 'webapp',
    env,
    // Specify a version number to identify the deployed version of your application in Datadog
    version: process.env.NEXT_PUBLIC_WEBAPP_VERSION,
    // Sending all logs instead of sampling
    sessionSampleRate: 100,
    // This can be very noisy so we're turning it off for now
    forwardErrorsToLogs: false,
  });
}
